import { useTranslation } from 'react-i18next';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { type Locale } from '@/i18n/locale';
import { useLocale } from '@/i18n/LocaleProvider';

export function LanguageSwitcher() {
  const { locale, setLocale } = useLocale();
  const { t } = useTranslation();
  return (
    <Select value={locale} onValueChange={v => setLocale(v as Locale)}>
      <SelectTrigger className="h-9 w-[110px]" aria-label={t('common.language')}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="en">English</SelectItem>
        <SelectItem value="th">ไทย</SelectItem>
      </SelectContent>
    </Select>
  );
}
